import { TabViewModel } from '@core/models/tab-view.model';

export const INSTALLATION_GROUP_DETAIL_TABS_VIEW: Array<TabViewModel> = [
  {
    index: 0,
    title: 'installationGroups.detail.general',
    route: 'general',
  },
  {
    index: 1,
    title: 'installationGroups.detail.locations',
    route: 'locations',
  },
  {
    index: 2,
    title: 'installationGroups.detail.devices',
    route: 'devices',
  },
];

// Appended after the tabs every user has, so adding it for some users moves none of theirs: the
// tab bar selects by index.
export const INSTALLATION_GROUP_INSTALLATIONS_TAB: TabViewModel = {
  index: 3,
  title: 'installationGroups.detail.installations',
  route: 'installations',
};
